<template>
  <div :class='$style.login'>
    <h1 :class='$style.title'>シングルサインオン</h1>

    <h2 :class="$style.sub">ゆにおん名： {{ union_name }}</h2>

    <!-- ローディング中の表示 -->
    <div v-if="loading" :class="$style.loading_wrap">
      <base-icon name="spinner" size="32px" spin />
    </div>

    <!-- IDプロバイダーのボタン表示 -->
    <div v-else-if="idpList && idpList.length">
      <div v-for="idp in idpList" :key="idp.saml2_tenant_id" :class="$style.next_button_wrap">
        <base-button display='inline-block' width='100%' height='50px' @click="handleIdpLogin(idp.idp_login_url)">
          {{ idp.key }}
        </base-button>
      </div>
    </div>

    <div v-else-if="idpList && !idpList.length">
      <p>IDプロバイダーが見つかりませんでした。</p>
    </div>

  </div>
</template>

<script>
import VueCookies from "vue-cookies"
import BaseButton from '@/components/base/BaseButton/BaseButton'
import BaseIcon from '@/components/base/BaseIcon/BaseIcon'
const cookies = VueCookies

export default {
  name: 'LoginSsoIdp',
  components: { BaseButton, BaseIcon },
  data() {
    return {
      union_key: '',
      union_name: '', // union_nameを追加
      processing: false,
      idpList: null, // idpListを追加
      loading: true // ローディング状態を管理
    }
  },
  created: async function () {
    // /api/v1.2/auth/saml/idp/list を呼び出し
    this.loading = true
    this.processing = true

    // union_keyをクエリパラメータから取得

    try {
      const result = await this.$axios.get(`/api/${this.$constants.API_VERSION}/auth/saml/idp/list`, {
        params: {
          union_key: this.$route.query.union_key,
          is_sp: this.$route.query.is_sp || 0
        },
      });
      if (result.data && result.data.value) {
        console.log(result.data.value)
        this.union_name = result.data.value.union_name
        // 変数idpListに格納
        this.idpList = result.data.value.idp_list
      } else {

        console.error('No value found in the response')
      }
    } catch (error) {
      console.error('An error occurred during the API call:', error)

      // バリデーションエラーの場合は404ページに遷移
      if (error.response) {
        this.$router.push('/404')
      }
    } finally {
      this.loading = false
      this.processing = false;
    }
  },
  methods: {
    handleIdpLogin(idpLoginUrl) {
      // IDプロバイダーのログインURLに遷移
      window.location.href = idpLoginUrl
    },
    linkClicked() {
      const url = '/open/ju_setting'
      // this.$loginfo(this.$route.query.redirect)
      if (this.$route.query.redirect) {
        this.$router.push(`${url}?redirect=${this.$route.query.redirect}`)
      } else {
        this.$router.push(url)
      }
    },
    registration: function () {
      cookies.remove('redirect_url')
      var redirect_url = '/home/home'
      if (this.$route.query.redirect) {
        redirect_url = this.$route.query.redirect
      }
      cookies.set('redirect_url', redirect_url)
      this.$router.push('/open/registration')
    },

    submit: async function () {
      // /api/v1.2/auth/saml/idp/list を呼び出し

      this.$router.app.$emit('show-spinner', true)
      this.processing = true
      try {
        const result = await this.$axios.get(`/api/${this.$constants.API_VERSION}/auth/saml/idp/list`, {
          params: {
            union_key: this.union_key
          },
        });
        if (result.data && result.data.value) {
          console.log(result.data.value)
          // レスポンスを受け取ったら /open/login/sso/listに遷移
        } else {

          console.error('No value found in the response')
        }
      } catch (error) {

        console.error('An error occurred during the API call:', error)
      } finally {
        this.$router.app.$emit('show-spinner', false);
        this.processing = false;
      }
    }
  }
}
</script>
<style lang='scss' module>
.login {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 68px 25px 47px 25px;
  box-sizing: border-box;
  text-align: left;

  @include mobile() {
    width: 375px;
    padding: 42px 32px 26px 32px;
  }
}

.title {
  margin-top: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  margin-bottom: 70px;

  @include mobile() {
    font-size: 24px;
    margin-bottom: 60px;
  }
}

.sub {
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
  color: $fontBlack;
  margin-top: 0;
  margin-bottom: 12px;
}

.button_wrap {
  &:not(last-child) {
    margin-bottom: 58px;
  }
}

.button {
  height: 50px !important;
  font-size: 16px !important;
  font-weight: bold !important;
}

.link_wrap {
  margin-top: auto;
  text-align: center;
}

.next_button_wrap {
  margin-top: 50px;
}

.link {
  display: block;
  font-size: 13px;
  line-height: 30px;
  color: $fontBlack;
  margin-top: 0;
  margin-bottom: 0px;
}

.loading_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

.loading_text {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
}
</style>
